import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EURoutingModule } from './eu-routing.module';

@NgModule({
  declarations: [],
  imports: [CommonModule, EURoutingModule],
})
export class EUModule {}
